import { Pet } from "../types";
import { comparePetsByName } from "./comparePetsByName";

const apiUrlProduction =
  "https://my-json-server.typicode.com/gugol2/pet-db/pets";

const apiUrlDevelopment = "http://localhost:3002/pets";

const apiUrl =
  process.env.NODE_ENV === "development" ? apiUrlDevelopment : apiUrlProduction;

export const getPetsOrdered = async (): Promise<Pet[]> => {
  try {
    const response = await fetch(apiUrl, {});
    const pets = await response.json();
    const sortedPets = [...pets].sort(comparePetsByName);
    return sortedPets;
  } catch (error) {
    console.error("Error fetching pets:", error);
    throw error;
  }
};
